export const MARGINS = { top: 32, right: 32, bottom: 32, left: 32 };

export const WHTITE_COLOR = 'white';

export const INNER_RADIUS = 0.6;

export const ARC_LABELS_RADIUS_OFFSET = 0.5;

export const LEGENDS = [
  {
    anchor: 'bottom',
    direction: 'row',
    symbolShape: 'circle',
    translateY: 32,
    itemWidth: 80,
    itemHeight: 18,
  },
] as const;

export const THEME = {
  labels: {
    text: {
      fontSize: 16,
      fontWeight: 'bold',
    },
  },
};

export const MOBILE_THEME = {
  labels: {
    text: {
      fontSize: 12,
    },
  },
};

export const PIE_COLORS = { datum: 'data.color' };

export const COLORS = {
  PENDING: '#ea5127',
  SUBMITTED: '#1b7b3e',
  CLOSED: '#0000fe',
} as const;
